<div
  class="simulation-row flex items-center gap-3 px-3 py-2.5 cursor-pointer transition-colors hover:bg-surface-50 dark:hover:bg-surface-800 border-surface-200 dark:border-surface-700"
  [class.border-b]="!isLast()"
  (click)="open.emit()"
>
  <p-button
    [icon]="favouritePending() ? 'fa-solid fa-spinner fa-spin' : (simulation().favourite ? 'fa-solid fa-star' : 'fa-regular fa-star')"
    [disabled]="favouritePending()"
    [styleClass]="'p-button-sm p-button-text' + (simulation().favourite ? ' text-yellow-500' : '')"
    [pTooltip]="(simulation().favourite ? 'simulator.history.unfavourite' : 'simulator.history.favourite') | translate"
    (click)="$event.stopPropagation(); favouriteToggled.emit()">
  </p-button>

  <div class="min-w-0 flex-1">
    <div class="font-medium truncate">
      @if (simulation().name) {
        {{ simulation().name }}
      } @else {
        {{ elementLabel(simulation().elementType) | translate }} {{ simulation().geometry?.thickness_m }}m
      }
    </div>
    <div class="text-xs text-surface-500 truncate">
      {{ mixtureLabel(simulation()) || ('simulator.history.custom' | translate) }}
    </div>
  </div>

  @if (riskSeverity(); as severity) {
    <p-tag [severity]="severity" [value]="('simulator.history.risk-prefix' | translate) + (riskLabel(simulation().results?.overallCrackingRisk) | translate)"></p-tag>
  }

  <div class="hidden sm:flex flex-col items-end shrink-0 min-w-[5rem]">
    <span class="font-semibold">{{ simulation().results?.peakCoreTempC | number:'1.1-1' }}°C</span>
    <span class="text-xs text-surface-500">{{ 'simulator.history.col-peak' | translate }}</span>
  </div>

  <div class="hidden lg:flex flex-col items-end shrink-0 min-w-[6rem]">
    <span class="text-sm">{{ simulation().pourDate | date:'dd/MM/yyyy' }}</span>
    <span class="text-xs text-surface-500">{{ 'simulator.history.col-date' | translate }}</span>
  </div>

  <p-button
    icon="fa-solid fa-eye"
    styleClass="p-button-sm p-button-text"
    (click)="$event.stopPropagation(); open.emit()">
  </p-button>
</div>
